module.exports = __webpack_public_path__ + "static/media/theme-puzzle.17b4462e.svg";